// Copyright © 2021 Move Closer
export const defaultValidationClassMap = {
    invalid: '--invalid',
    valid: '--valid'
};
